'use strict';
var $ = require('jquery');

$(function () {
    /*
    var breakpoint = 990;
    const data_url = $('#hero-img').attr('data-url');
    const heroImg = document.getElementById('hero-img');
    const heroVideo = document.getElementById('hero-video');
    if (heroImg || heroVideo) {
        heroImg.style.backgroundImage = `url("${data_url}")`;


        loadVideo();

        // Pause when page is not in the foreground
        $(window).on( "blur", function() {
            $('#hero-video')[0].pause();
        });

        // Play when page returns to the foreground
        $(window).on( "focus", function() {
            if ($(document).width() > breakpoint) {
                var isPlaying = $('#hero-video')[0].currentTime > 0 && !$('#hero-video')[0].paused && !$('#hero-video')[0].ended
                    && $('#hero-video')[0].readyState > 2;

                if (!isPlaying) {
                    $('#hero-video').css(
                        { 'display': 'block' }
                    );
                    $('#hero-video')[0].play();
                }
            }
        });

        // Play video when page resizes
        $(window).on( "resize", function() {
            loadVideo();
        });

        // Play when page returns from browser history button
        window.onpopstate = function () {
            if ($(document).width() > breakpoint) {
                var isPlaying = $('#hero-video')[0].currentTime > 0 && !$('#hero-video')[0].paused && !$('#hero-video')[0].ended
                    && $('#hero-video')[0].readyState > 2;

                if (!isPlaying) {
                    $('#hero-video').css(
                        { 'display': 'block' }
                    );
                    $('#hero-video')[0].play();
                }
            }
        };

        function loadVideo() {
            var video = document.getElementById('hero-video');

            // Remove existing source tags for mobile
            if ($(document).width() < breakpoint + 1) {
                while (video.firstChild) {
                    video.removeChild(video.firstChild);
                }
            }
            if ($(document).width() > breakpoint) {
                if (document.querySelectorAll("#hero-video > source").length === 0) {
                    var source1 = document.createElement('source');
                    var dataUrl = video.getAttribute('data-url');

                    source1.setAttribute('src', dataUrl);
                    source1.setAttribute('type', 'video/mp4');

                    video.appendChild(source1);
                }
                // Play the video
                var isPlaying = $('#hero-video')[0].currentTime > 0 && !$('#hero-video')[0].paused && !$('#hero-video')[0].ended
                    && $('#hero-video')[0].readyState > 2;

                $('#hero-video').css(
                    { 'display': 'block' }
                );
                if (!isPlaying) {
                    $('#hero-video')[0].play();
                }
            } else {
                if ($(document).width() < breakpoint + 1) {

                    $('#hero-video')[0].removeAttribute('src');
                    $('#hero-video').css(
                        { 'display': 'none' }
                    );


                }
            }
        }
    }
*/


    const isFrontPage = $('#frontpage-hero');

    if(isFrontPage.length > 0){

        var indx = 0;
        var pauseSlider = false;

        const handlechangeSlide = (isFirst = false) => {

            $('.slider-slide').hide();
    
            $(`.slide-${indx}`).fadeIn(isFirst ? 50 : 500);
    
            const currentVideo = $(`.video-idx-${indx}`);

            const currentImage = $(`.img-idx-${indx}`);

            const currentBtn = $(`.slide-btn-index-${indx}`);

            // BTN
            $('.slide-btn').removeClass('active');
            currentBtn.addClass('active');
    
            // Video
            const videoUrl = currentVideo.data('url');
            currentVideo.attr('src', videoUrl);

            // BG IMAGE
            const ImgUrl = currentImage.data('url');
            currentImage.css('background-image', `url("${ImgUrl}")`);
    
        }

        // Play fist slide
        if(!isFrontPage.data("autoplay") == 1){
           handlechangeSlide(true)
        }

        const showPlay = () => {
            $('.play-button').fadeIn(500)
        }

        // Change slide
        $('.slide-btn').on('click', function(){
    
            const btnIndx = $(this).data('btn-indx');

            pauseSlider = true;
            indx = btnIndx;

            handlechangeSlide()

            setTimeout(showPlay, 1000);
    
        })


        // Auto change slide if autoplay is on
        if(isFrontPage.data("autoplay") == 1){

            const slides = $('.slider-slide');
            const numSlides = slides.length;
    
            const autoChangeSlide = (isFirst = false) => {
                if(!pauseSlider){
                    const slideTime = $(slides[indx]).data('slide-time'); 
                    handlechangeSlide(isFirst);
                    setTimeout(autoChangeSlide, slideTime);
                    indx = (indx + 1) % numSlides;
                }
            };
    
            handlechangeSlide(true);

            autoChangeSlide(true);

            $('.play-button').on('click', function(){

                pauseSlider = false;

                $('.play-button').hide();

                const slideTime = $(slides[indx]).data('slide-time'); 
                setTimeout(autoChangeSlide, slideTime);
                
            })

        }



    }




});